import {Alert, AlertDescription, AlertIcon, AlertTitle} from '@chakra-ui/react'
import {supported} from '@mapbox/mapbox-gl-supported'
import {useEffect} from 'react'

import useToast from 'lib/hooks/use-toast'
import {ExternalLinkIcon} from 'lib/components/icons'

export default function WebGlIsSupportedToaster() {
  const toast = useToast()
  useEffect(() => {
    if (!supported()) {
      toast({
        duration: null,
        render: () => (
          <Alert rounded='md' status='error' shadow='lg'>
            <AlertIcon />
            <div>
              <AlertTitle>WebGL not supported by browser</AlertTitle>
              <AlertDescription>
                WebGL support is required for rendering maps. Check your browser
                and device compatibility{' '}
                <a
                  href='/debug/webgl'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  here <ExternalLinkIcon style={{display: 'inline-block'}} />
                </a>
                .
              </AlertDescription>
            </div>
          </Alert>
        )
      })
    }
  }, [toast])

  return null
}
